import { render, staticRenderFns } from "./DetailExternal.vue?vue&type=template&id=14936063"
import script from "./DetailExternal.vue?vue&type=script&lang=js"
export * from "./DetailExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports